const mutations = {
  USER(state, res) {
    state.user = res;
    state.userPhoto = res.profile_picture.url;
  },
  PHOTO_USER(state, res) {
    state.userPhoto = res;
  },
  RAPPY_PAY_MESSAGE(state, data) {
    state.rappyPayMessage = data;
  },
  UNIVERSITY_VARIABLES(state, data) {
    state.universityVariables = data;
  },
  QUESTIONS(state, data) {
    state.questions = data;
  },
  PSE_BANKS(state, data) {
    state.pseBanks = data;
  },
  CURRENT_ADDRESS(state, data) {
    state.currentAddress = data;
  },
  CURRENT_CITY_ZONE(state, data) {
    state.currentCityZone = data;
  },
  CURRENT_PROGRAM(state, data) {
    state.currentProgram = data;
  },
  TRAITS(state, data) {
    state.traits = data;
  },
  CURRENT_PAYMENT_METHOD(state, data) {
    state.currentPaymentMethod = data;
  },
  PSE_INFORMATION(state, data) {
    state.pseInformation = data;
  },
  BOUGHT_PRODUCTS(state, data) {
    if (data && data.length) {
      const productsStr = data;
      const productsArr = productsStr.split(", ");
      state.boughtProducts = productsArr.map((item) => {
        return parseInt(item);
      });
    }
  },
  ACCEPTANCE_TOKEN(state, data) {
    state.acceptanceToken = data;
  },
  RECENT_PRODUCTS(state, data) {
    state.recentProducts = data;
  },
  IS_ON_DEMAND_VALID(state, data) {
    state.isOnDemandValid = data;
  },
};

export default mutations;
